/* Parallaxe du média de fond des sections "Colonnes à icônes".
   Custom element : se réinitialise tout seul quand l'éditeur de thème
   recharge une section. Ne fait rien si data-parallax != "scroll". */

if (!customElements.get('parallax-media')) {
  class ParallaxMedia extends HTMLElement {
    connectedCallback() {
      if (this.dataset.parallax !== 'scroll') return;

      this.range = parseFloat(this.dataset.intensity) || 0;
      if (this.range <= 0) return;

      this.reverse = this.dataset.direction === 'reverse';
      this.allowMobile = this.dataset.mobile === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.visible = false;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);

      this.observer = new IntersectionObserver(
        (entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.request();
        },
        { rootMargin: '150px 0px' }
      );
      this.observer.observe(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.request();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    get active() {
      if (this.reducedMotion.matches) return false;
      if (!this.allowMobile && window.innerWidth < 750) return false;
      return true;
    }

    onScroll() {
      if (this.visible) this.request();
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.update);
    }

    update() {
      this.ticking = false;

      if (!this.active) {
        this.style.setProperty('--ic-parallax-y', '0px');
        return;
      }

      const rect = this.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight;

      // -1 quand la section sort par le haut, 0 au centre, +1 quand elle entre par le bas
      const progress = (rect.top + rect.height / 2 - viewport / 2) / ((viewport + rect.height) / 2);
      const clamped = Math.max(-1, Math.min(1, progress));

      // Sens "classique" : le fond retarde sur le défilement de la page
      const y = clamped * this.range * (this.reverse ? 1 : -1);

      this.style.setProperty('--ic-parallax-y', y.toFixed(1) + 'px');
    }
  }

  customElements.define('parallax-media', ParallaxMedia);
}
